import { render } from "./HPToday.vue?vue&type=template&id=66df21b5&scoped=true"
import script from "./HPToday.vue?vue&type=script&lang=js"
export * from "./HPToday.vue?vue&type=script&lang=js"

import "./HPToday.vue?vue&type=style&index=0&id=66df21b5&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df21b5"]])

export default __exports__